import { render, staticRenderFns } from "./SimilarContactModal.vue?vue&type=template&id=62132643&scoped=true"
import script from "./SimilarContactModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimilarContactModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SimilarContactModal.vue?vue&type=style&index=0&id=62132643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62132643",
  null
  
)

export default component.exports